import type { LivePhase } from "~/features/live/types";
import type { CallPhase } from "~/stores/useCallStore";

/** 通話中（発信中・着信中・通話接続中）かどうかを判定する */
export const isCallPhaseActive = (phase: CallPhase): boolean =>
  phase.type === "outgoingConnecting" ||
  phase.type === "incomingRinging" ||
  phase.type === "inCall";

/** 配信視聴中かどうかを判定する */
export const isLivePhaseActive = (phase: LivePhase): boolean =>
  phase === "connecting" || phase === "connected";
